import { render } from "./ZapiModalConfirmacionVenta.vue?vue&type=template&id=8b5f1a36&scoped=true"
import script from "./ZapiModalConfirmacionVenta.vue?vue&type=script&lang=js"
export * from "./ZapiModalConfirmacionVenta.vue?vue&type=script&lang=js"

import "./ZapiModalConfirmacionVenta.vue?vue&type=style&index=0&id=8b5f1a36&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b5f1a36"]])

export default __exports__